import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const dpRoot = `Catalogs|Emails|Email Content Form|`;

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type NameStart = 'SPEmailContentForm';
export type EmailContentFormLoc =
	| `${NameStart}SubjectFieldError`
	| `${NameStart}LabelSubject`
	| `${NameStart}LabelPlainTextBody`
	| `${NameStart}LabelHtmlBody`
	| `${NameStart}ButtonCancel`
	| `${NameStart}ButtonSave`;

export const emailContentFormLocs: LocDefs<EmailContentFormLoc> = {
	SPEmailContentFormSubjectFieldError: {
		defaultValue: 'Subject is required',
		description: 'Error message if subject is empty.',
		displayPath: `${dpRoot}Subject Field Error`,
		displayType: 'Error',
		...sharedProperties,
	},
	SPEmailContentFormLabelSubject: {
		defaultValue: 'Subject',
		description: 'Label for: Subject',
		displayPath: `${dpRoot}Subject`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.Subject',
		...sharedProperties,
	},
	SPEmailContentFormLabelPlainTextBody: {
		defaultValue: 'Plain Text Body',
		description: 'Label for: Plain Text Body',
		displayPath: `${dpRoot}Plain Text Body`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.PlainText',
		...sharedProperties,
	},
	SPEmailContentFormLabelHtmlBody: {
		defaultValue: 'HTML Body',
		description: 'Label for: HTML Body',
		displayPath: `${dpRoot}HTML Body`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.HTMLBody',
		...sharedProperties,
	},
	SPEmailContentFormButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Button for: Cancel',
		displayPath: `${dpRoot}Cancel`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.ContentCancel',
		...sharedProperties,
	},
	SPEmailContentFormButtonSave: {
		defaultValue: 'Save',
		description: 'Button for: Save',
		displayPath: `${dpRoot}Save`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.ContentSave',
		...sharedProperties,
	},
};

export type SPEmailContentFormLocType = LocMap<EmailContentFormLoc>;
